module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "rgb(232, 52, 61)"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header3-footer"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/new_year_activity/new_year_icon21.png")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "header3-but1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$router.push('/newyearactivity')
      }
    }
  }, [_vm._v("返 回")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header2"
  }, [_c('div', {
    staticClass: "header3-main"
  }, [_c('h1', [_vm._v("活动规则")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF",
      "margin": "5px 0"
    }
  }, [_vm._v("新用户")]), _vm._v(" "), _c('p', [_vm._v("\n                1. 新用户扫描推荐人的二维码关注天一互联微信公众号,填写个人手机号认证后,可参与此活动; 已关注过公众号但从未在天一互联公众号平台购买过任何产品的用户，可参与此活动。"), _c('br'), _vm._v("\n                2. 填写公司的在线调研表单并成功提交后，可免费获得一次护眼水体验的资格(仅需支付12元快递费)，同时获得一个现金红包，此红包可用在体验装快递费的结算支付上。"), _c('br'), _vm._v("\n                3. 体验资格使用后，可再次获得一个正装产品的抵扣红包。此红包可以用在正装产品的结算支付上。"), _c('br'), _vm._v("\n                注： 所有赠送的红包会在下单时自动生效，无需额外选择和操作，系统会自动抵扣红包金额。"), _c('br')]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "#FFF",
      "margin": "5px 0"
    }
  }, [_vm._v("推荐人")]), _vm._v(" "), _c('p', [_vm._v("\n                1. 请先阅读上方“新用户”区块。"), _c('br'), _vm._v("\n                2. 推荐人可推荐自己的亲朋好友扫描您的二维码关注天一互联微信公众号。"), _c('br'), _vm._v("\n                2. 新推荐的用户完成体验装产品和正装产品支付后，系统将自动生成一个现金红包，发送到推荐人的账户余额。该红包可消费可提现，不受任何限制。"), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abeee5a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newYearActivity/rule.vue
// module id = 697
// module chunks = 0